module.exports = __webpack_public_path__ + "fonts/IQOS-Regular.83668f5.ttf";